import { uri } from "../constants";

export const getPlatforms = async () => {
  try {
    const response = await fetch(`${uri}/platforms`);
    if (!response.ok) throw new Error('Failed to fetch platforms');
    return await response.json();
  } catch (error) {
    console.error('Error fetching platforms:', error);
    throw error;
  }
};

export const createPlatform = async (platformData) => {
  try {
    const response = await fetch(`${uri}/platforms`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(platformData)
    });
    if (!response.ok) throw new Error('Failed to create platform');
    return await response.json();
  } catch (error) {
    console.error('Error creating platform:', error);
    throw error;
  }
};

export const updatePlatform = async (platformId, platformData) => {
  try {
    const response = await fetch(`${uri}/platforms/${platformId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(platformData)
    });
    if (!response.ok) throw new Error('Failed to update platform');
    return await response.json();
  } catch (error) {
    console.error('Error updating platform:', error);
    throw error;
  }
};

export const deletePlatform = async (platformId) => {
  try {
    const response = await fetch(`${uri}/platforms/${platformId}`, {
      method: 'DELETE'
    });
    if (!response.ok) throw new Error('Failed to delete platform');
    return await response.json();
  } catch (error) {
    console.error('Error deleting platform:', error);
    throw error;
  }
};
